import { render, staticRenderFns } from "./Zaun24SuppliesBanner.vue?vue&type=template&id=45162bfc"
import script from "./Zaun24SuppliesBanner.vue?vue&type=script&lang=js"
export * from "./Zaun24SuppliesBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports